// extracted by mini-css-extract-plugin
module.exports = {"Gem":"nft-modal-details-sidebar_Gem__Clexd","AmountInPlaylist":"nft-modal-details-sidebar_AmountInPlaylist__DE2zq"};